import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa4ca638"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "title" }

import { ref } from 'vue';
import type { ComponentExposed } from 'vue-component-type-helpers';
import TableExpandableRows from './TableExpandableRows.vue';
import MultiStateButton from './MultiStateButton.vue';
import { DisplayableKeys } from '@/services/SorterService';
import useTableExpandableColumns, {ExpandState} from '@/services/composables/TableExpandableColumns';


export default /*#__PURE__*/_defineComponent({
  __name: 'TableExpandable',
  props: {
    modelValue: {},
    rows: {},
    maxRows: { default: 3 },
    expandedCols: {},
    cols: {},
    title: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emits = __emit;
__expose<{
    checkAll:()=>void;
}>({
    checkAll: ()=>table.value?.checkAll(),
});
const table = ref<ComponentExposed<typeof TableExpandableRows>>();
const {
  labels,
  expandState,
  curCols
} = useTableExpandableColumns(props, emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title) + ":", 1),
      (_ctx.expandedCols)
        ? (_openBlock(), _createBlock(MultiStateButton, {
            key: 0,
            modelValue: _unref(expandState),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(expandState) ? (expandState).value = $event : null)),
            states: _unref(labels),
            style: {"font-size":"0.6rem"}
          }, null, 8, ["modelValue", "states"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(TableExpandableRows, _mergeProps({
      ref_key: "table",
      ref: table
    }, _ctx.$attrs, {
      rows: _ctx.rows,
      cols: _unref(curCols),
      maxRows: _ctx.maxRows
    }), null, 16, ["rows", "cols", "maxRows"])
  ]))
}
}

})